import React from "react";
import { Link } from "react-router-dom";
import { FaLinkedin, FaFacebookF } from "react-icons/fa";
import "./Footer.css";
import logo from "../../assets/images/logo.png";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-col footer-col--brand">
          <img src={logo} alt="Logo NEXUS SOLUTIONS" className="footer-logo" loading="lazy" />
          <p className="footer-about">
            Agence digitale basee a Abidjan. On cree des sites web, applications mobiles
            et boutiques en ligne pour les entrepreneurs et PME ivoiriennes.
          </p>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/nexus-solutions-ci" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin size={20} />
            </a>
            <a href="https://www.facebook.com/nexussolutionsci" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FaFacebookF size={20} />
            </a>
            {/* <a href="https://wa.me/2250142578758" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <FaWhatsapp size={20} />
            </a> */}
          </div>
        </div>

        <div className="footer-col">
          <h4>Nos services</h4>
          <ul>
            <li><Link to="/services/developpement-web">Sites Web &amp; Landing Pages</Link></li>
            <li><Link to="/services/applications-mobiles">Applications Mobiles</Link></li>
            <li><Link to="/services/applications-e-commerce">E-commerce</Link></li>
            <li><Link to="/tarifs">Voir nos tarifs</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Entreprise</h4>
          <ul>
            <li><Link to="/about">A propos</Link></li>
            <li><Link to="/publications">Blog</Link></li>
            <li><Link to="/careers">Carrieres</Link></li>
            <li><Link to="/partenaires">Partenaires</Link></li>
          </ul>
        </div>

        <div className="footer-col footer-col--contact">
          <h4>Contact</h4>
          <p>Cocody, Angre, Abidjan — Cote d'Ivoire</p>
          <p>
            <a href="mailto:contact@nxs-solutions.com" className="footer-link">
              contact@nxs-solutions.com
            </a>
          </p>
          {/* <a
            href="https://wa.me/2250142578758?text=Bonjour%2C%20je%20souhaite%20un%20devis%20pour%20mon%20projet%20digital"
            target="_blank"
            rel="noreferrer"
            className="footer-wa-btn"
          >
            <FaWhatsapp size={15} />
            Ecrire sur WhatsApp
          </a> */}
          <div style={{ marginTop: '14px' }}>
            <Link to="/devis" className="footer-cta">Devis gratuit</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>&copy; {new Date().getFullYear()} NEXUS SOLUTIONS — Tous droits reserves</span>
        <span className="footer-bottom__sep">·</span>
        <Link to="/mentions-legales" className="footer-legal-link">Mentions legales</Link>
        <span className="footer-bottom__sep">·</span>
        <Link to="/mentions-legales#cookies" className="footer-legal-link">Cookies</Link>
      </div>
    </footer>
  );
}
